// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import SmileOutlined from 'D:/gitee/xy-home/xy-home-web/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/SmileOutlined';
import CrownOutlined from 'D:/gitee/xy-home/xy-home-web/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/CrownOutlined';
export default { SmileOutlined, CrownOutlined };
